import { render, staticRenderFns } from "./super-admin-page.vue?vue&type=template&id=0eb8027c&"
import script from "./super-admin-page.vue?vue&type=script&lang=ts&"
export * from "./super-admin-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports